import { ArrowDownRight, BookOpenText, Download, ExternalLink } from "lucide-react";

export type DocumentMeta = {
  id: string;
  index: string;
  title: string;
  subtitle: string;
  description: string;
  author: string;
  publishedAt: string;
  sourceUrl: string;
  pdf: string;
  sourceIds: string[];
  referenceIds: string[];
};

type Props = {
  documents: DocumentMeta[];
  activeId: string;
  onSelect: (id: string) => void;
};

export function DocumentLibrary({ documents, activeId, onSelect }: Props) {
  return (
    <section className="document-library" id="knowledge-map" aria-labelledby="library-title">
      <div className="section-heading">
        <h2 id="library-title">三份独立文档</h2>
        <p>每一份只围绕一篇原始文章重构，不混写来源，不共用结论段落。</p>
      </div>
      <div className="document-grid">
        {documents.map((document) => {
          const active = document.id === activeId;
          return (
            <article className={active ? "document-card is-active" : "document-card"} key={document.id}>
              <div className="document-card-top">
                <span>{document.index}</span>
                <BookOpenText aria-hidden="true" />
              </div>
              <h3>{document.title}</h3>
              <p className="document-subtitle">{document.subtitle}</p>
              <p>{document.description}</p>
              <div className="document-meta">{document.author} · {document.publishedAt}</div>
              <div className="document-card-actions">
                <button type="button" onClick={() => onSelect(document.id)} aria-current={active ? "true" : undefined}>
                  阅读这篇 <ArrowDownRight aria-hidden="true" />
                </button>
                <a href={`${import.meta.env.BASE_URL}${document.pdf}`} download aria-label={`下载 ${document.title} PDF`}>
                  <Download aria-hidden="true" />
                </a>
                <a href={document.sourceUrl} target="_blank" rel="noreferrer" aria-label={`打开 ${document.title} 原文`}>
                  <ExternalLink aria-hidden="true" />
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
